import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    const finish = async () => {
      if (!sessionId) { navigate("/admin"); return; }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", "/admin/dashboard");
        navigate("/admin/dashboard", { state: { user: res.data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Authentication failed";
        navigate("/admin?error=" + encodeURIComponent(msg));
      }
    };
    finish();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-forest-dark">
      <div className="text-center text-offwhite">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-amber-brand border-t-transparent" />
        <p className="font-mono text-xs uppercase tracking-widest text-offwhite/70">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
